import request from '../utils/request';

const momentPostAuditQueueApi = {
  // 分页查询动态审核队列
  pageAuditQueues: (params = {}) => {
    return request.post('/moment-post-audit-queue/page', {
      page: 1,
      pageSize: 10,
      ...params
    });
  },

  // 获取动态审核队列详情
  getAuditQueueDetail: (id) => {
    return request.get(`/moment-post-audit-queue/${id}`);
  },

  // 审核动态
  auditMomentPostQueue: (id, data) => {
    return request.put(`/moment-post-audit-queue/audit/${id}`, data);
  },

  // 删除动态审核队列
  deleteAuditQueue: (id) => {
    return request.delete(`/moment-post-audit-queue/${id}`);
  }
};

export default momentPostAuditQueueApi;
